

import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import { ExplanationOfBenefitBundle } from '../../../../../types/FHIRTypes/Bundle'
import FhirLoader from '../../../../FhirLoader'
import { isExplanationOfBenefitBundle } from '../../../../../typeGuards/fhirTypes'
import { ExplanationOfBenefitTable } from '@teschglobal/tg-fhir-react-components'

type EobListProps = {
  eobData: ExplanationOfBenefitBundle;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const EobList: FC<EobListProps> = ({ eobData, handleChangePage, isFetching, totalPages, currentPage }) => {
  if (!isExplanationOfBenefitBundle(eobData)) return null

  const patientEobs = eobData && eobData.entry ? eobData.entry.map((eob) => eob.resource) : []

  if (isFetching) {
    return <FhirLoader message="Loading..." />
  }

  return (
    <>
      {
        eobData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <span role="status" aria-live="polite">{eobData?.total.toLocaleString()} record(s) found</span>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
      <ExplanationOfBenefitTable
        data={patientEobs}
      />
      {
        eobData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
    </>
  )
}

export default EobList